// extracted by mini-css-extract-plugin
module.exports = {"root":"MakerHubProjectYouTubePlayer_root__o12P6"};